module.exports = __webpack_public_path__ + "img/组 5.483c0721.png";